<script>
    import {_, locale} from 'svelte-i18n';
    import Item from './Item.svelte';
    import {gameConfig} from "../../stores.js";

    let { item, gameItem } = $props();
    let itemDetails = $state({});

    function setItemDetails() {
        itemDetails.title = $_('EquipmentItem' + gameItem.equipmentId);
        itemDetails.description = $_(
            'EquipmentItem' + gameItem.equipmentId + 'Description',
        );
        itemDetails.icon = 'commander_equipment_' + gameItem.equipmentId;
        itemDetails.amount = item.amount;
        itemDetails.rarity = gameItem.rarity;
        itemDetails.expireAt = $gameConfig?.temporaryItems?.[item.id];
        itemDetails.claimed = item.claimed;
    }

    $effect(() => {
        $locale;
        setItemDetails();
    });
</script>

<Item {itemDetails}/>
